export const jivoOpen = () => {
    // @ts-expect-error
    window.jivo_api?.open();
};
